'use client';

import { Button } from '@packages/shared/src/ui/Button/Button';
import { useIntl } from 'react-intl';

export type AddToBasketLayerErrorFallbackProps = {
  reset: () => void;
};

export const AddToBasketLayerErrorFallback = ({ reset }: AddToBasketLayerErrorFallbackProps) => {
  const { formatMessage } = useIntl();

  return (
    <div className="flex flex-col gap-3">
      {formatMessage({
        id: 'addToBasketLayer.error.message',
        defaultMessage: 'Produkt konnte nicht geladen werden...',
      })}
      <Button
        onClick={() => {
          reset();
        }}
      >
        {formatMessage({
          id: 'addToBasketLayer.error.button.text',
          defaultMessage: 'Erneut versuchen',
        })}
      </Button>
    </div>
  );
};
